import { render, staticRenderFns } from "./AddAccount.vue?vue&type=template&id=cbf1df9e&scoped=true&"
import script from "./AddAccount.vue?vue&type=script&lang=js&"
export * from "./AddAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddAccount.vue?vue&type=style&index=0&id=cbf1df9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf1df9e",
  null
  
)

export default component.exports